import * as ActionTypes from 'constants';

export const toggleJobNimbusAuthError = bool => ({ type: ActionTypes.TOGGLE_JOB_NIMBUS_AUTH_ERROR, payload: bool });



// WEBPACK FOOTER //
// ./src/common/actions/integrations.js